import { render, staticRenderFns } from "./workshop-form.vue?vue&type=template&id=bf3d3e42&scoped=true"
import script from "./workshop-form.vue?vue&type=script&lang=js"
export * from "./workshop-form.vue?vue&type=script&lang=js"
import style0 from "./workshop-form.vue?vue&type=style&index=0&id=bf3d3e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3d3e42",
  null
  
)

export default component.exports